import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Pagination from 'components/Pagination'
import useInnerPage from 'store/InnerPageProvider'
import OrderingAndfilters from './OrderingAndFilters'
import { BrowserView } from 'components/DeviceDetect'
import ProductItem from 'components/Widgets/ProductItem'
import { CategorySale, NoProductFoundDiv } from 'style/Category.style'

export default function InnerPageProducts(props) {
  const {
    products: { products, pagination },
    clearFilters,
  } = useInnerPage()
  const { category } = props

  if (Array.isArray(products) && !products.length > 0) {
    return (
      <div className="w-full flex flex-col justify-center items-center p-8 bg-gray-50 rounded-2xl text-center">
        <div className="text-4xl mb-4">🔍</div>
        <div className="text-gray-700 text-base mb-6">
          სამწუხაროდ პროდუქტები ვერ მოიძებნა
        </div>
        <Link
          to="/"
          className="px-6 py-3 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
        >
          მთავარ გვერდზე დაბრუნება
        </Link>
      </div>
    )
  }

  return (
    <Fragment>
      <BrowserView>
        <OrderingAndfilters total={pagination?.total} />
      </BrowserView>
      <CategorySale>
        {(products || []).map(product => (
          <ProductItem item={product} />
        ))}
      </CategorySale>
      <Pagination data={pagination} />
      {category.text ? (
        <div
          className="mt-8 format-html"
          dangerouslySetInnerHTML={{ __html: category.text }}
        />
      ) : null}
    </Fragment>
  )
}
